module.exports = __webpack_public_path__ + "img/03.3d00acf9.jpg";